<template>
    <v-tabs>
        <v-tab @click="seleccion(0)">Ensayos</v-tab>
        <v-tab @click="seleccion(1)">HMI</v-tab>
    </v-tabs>
</template>

<script>

export default {
    methods: {
        seleccion(a){
            console.log("Seleccionado",a)
            this.$emit('seleccion',a)  
        }
  },
}
</script>

<style>
    
</style>